import React from 'react';
import TMWings from './tm_wings.svg';

type TMWingsAnimationProps = Omit<React.ObjectHTMLAttributes<HTMLObjectElement>, 'data' | 'type'>;

const TMWingsAnimation = (props: TMWingsAnimationProps) => {
    return <object aria-label="TMWingsIcon" {...props} data={TMWings} type="image/svg+xml" />;
};

export default TMWingsAnimation;
